export enum LookupType {
  Explore = "Explore",
  CNAM = "CNAM",
  History = "History"
}
